import { Component, OnInit, Input, EventEmitter, Output, inject } from '@angular/core';

import { MapaFacilService } from './mapa-facil.service';
import { MapaFacilViewComponent } from './mapa-facil-view.component';
import { EditingConfig } from './interfaces';

@Component({
  selector: 'app-mapa-facil',
  template: `
    <app-mapa-facil-view></app-mapa-facil-view>
    <ng-content></ng-content>
  `,
  imports: [MapaFacilViewComponent],
})
export class MapaFacilComponent implements OnInit {
  private mapaService = inject(MapaFacilService);

  @Input() nombreMap?: string;
  @Input() inputDireccion?: boolean;
  @Input() setMarker?: boolean;
  @Input() editingConfig?: EditingConfig;
  @Input() disablePopups?: boolean; // Deshabilita popups al hacer click en markers
  @Output() inicializado = new EventEmitter<void>();

  async ngOnInit() {
    // Clear any previous map data
    await this.mapaService.clearMap(
      this.nombreMap,
      this.inputDireccion,
      this.setMarker,
      this.editingConfig,
      this.disablePopups,
    );
    const checkInterval = setInterval(() => {
      if (this.mapaService.map) {
        clearInterval(checkInterval);
        this.inicializado.emit();
      }
    }, 100);
  }
}
